// ════════════════════════════════════════════════════
//  DEEP SPACE OPS — RTS ENGINE
// ════════════════════════════════════════════════════

// World map size
const RW=4000, RH=1400;
// Viewport (canvas element size)
const VW=1200, VH=580;
const PLAYER_BASE_X=160, ENEMY_BASE_X=RW-160, BASE_Y=RH/2;
const BUILDING_HEALTH={
  base:300,
  structure:160,
  cannon:120,
  aerial:140,
};

// ── CENTRALIZED RTS STATE ──
// All mutable game state in one object. resetRtsState() restores defaults.
const S = {
  // game flow
  raf: null, frame: 0, speed: 1, gameOver: false, log: '',
  // resources & factions
  gold: {player:0, enemy:0},
  oil:  {player:0, enemy:0},
  // completed Research Lab tech — unlocks Warbot/Tank/Warship production
  research: {player:false, enemy:false},
  playerFaction: 'prism', enemyFaction: 'shadow',
  // base HP
  baseHP: BUILDING_HEALTH.base, enemyBaseHP: BUILDING_HEALTH.base,
  // entities
  entities: [], playerBase: null, enemyBase: null,
  particles: [], goldNodes: [], projectiles: [],
  map: null, mapDecor: [], mapSeed: 1,
  // selection / UI
  selected: [], buildPopupOpen: false, buildStructureMode: false, buildingSource: null, attackMoveMode: false,
  deployDarkShipMode: false,
  // AI
  aiTimer: 0,
  // camera
  camX: 0, camY: RH/2 - VH/2, camZoom: 1, mouseWorld: null,
  // performance stats (reset each game)
  stats: { kills:0, deaths:0, goldEarned:0, oilEarned:0, unitsBuilt:0 },
};

function resetRtsState(){
  S.raf=null; S.frame=0; S.speed=1; S.gameOver=false; S.log='';
  S.gold={player:0, enemy:0}; S.oil={player:0, enemy:0}; S.research={player:false, enemy:false}; S.baseHP=BUILDING_HEALTH.base; S.enemyBaseHP=BUILDING_HEALTH.base;
  S.entities=[]; S.playerBase=null; S.enemyBase=null;
  S.particles=[]; S.goldNodes=[]; S.projectiles=[];
  S.map=null; S.mapDecor=[];
  S.selected=[]; S.buildPopupOpen=false; S.buildStructureMode=false; S.buildingSource=null; S.attackMoveMode=false; S.deployDarkShipMode=false;
  S.aiTimer=0;
  S.stats={ kills:0, deaths:0, goldEarned:0, oilEarned:0, unitsBuilt:0 };
  S.camX=0; S.camY=RH/2-VH/2; S.camZoom=1; S.mouseWorld=null;
}

// ── CAMERA ──
let camDragging=false, camDragActive=false, camDragStartX=0, camDragStartY=0, camDragCamX=0, camDragCamY=0;
let dragSelActive=false, dragSelStartCX=0, dragSelStartCY=0, dragSelCurCX=0, dragSelCurCY=0;
const CAM_SPEED=14;
const CAM_ZOOM_FACTOR=1.06;
const keysHeld={};

function clampCam(){
  const vw=VW/S.camZoom, vh=VH/S.camZoom;
  S.camX=Math.max(0,Math.min(RW-vw,S.camX));
  S.camY=Math.max(0,Math.min(RH-vh,S.camY));
}

let cameraControlsInitialized = false;

function initCamera(playerFaction){
  S.camX = PLAYER_BASE_X - VW * 0.3;
  S.camY = RH/2 - VH/2;
  clampCam();
  if(!cameraControlsInitialized){
    cameraControlsInitialized = true;
    setupCameraControls();
  }
}

function setupCameraControls(){
  // Keyboard
  document.addEventListener('keydown', e=>{
    const game = document.getElementById('dso-game');
    if(!game || game.style.display==='none') return;
    if((e.key==='a'||e.key==='A') && S.selected.some(u=>u.side===mySide()&&u.type==='warrior')){
      S.attackMoveMode = true;
      rtsUpdateViewportCursor();
      rtsSetLog('Attack-move armed — click a destination.');
      e.preventDefault();
      return;
    }
    keysHeld[e.key] = true;
    // prevent page scroll with arrow keys when game is open
    if(['ArrowUp','ArrowDown','ArrowLeft','ArrowRight',' '].includes(e.key)) e.preventDefault();
  });
  document.addEventListener('keyup', e=>{ delete keysHeld[e.key]; });

  // Mouse drag — attach to the wrapper div
  const wrap = document.getElementById('rts-viewport-wrap');
  if(!wrap) return;

  wrap.addEventListener('mousedown', e=>{
    if(e.button !== 0) return;
    camDragging=false;
    camDragActive=true;
    camDragStartX=e.clientX; camDragStartY=e.clientY;
    dragSelActive=false;
    dragSelStartCX=e.clientX; dragSelStartCY=e.clientY;
    dragSelCurCX=e.clientX;   dragSelCurCY=e.clientY;
  });
  window.addEventListener('mousemove', e=>{
    const moved=Math.hypot(e.clientX-camDragStartX, e.clientY-camDragStartY);
    if(camDragActive && moved>6 && (e.buttons&1) && !S.buildStructureMode){
      camDragging=true;
      dragSelActive=true;
      dragSelCurCX=e.clientX; dragSelCurCY=e.clientY;
    }
    // track mouse in world coords for placement preview
    const canvas2=document.getElementById('rts-canvas');
    if(canvas2){
      const rect=canvas2.getBoundingClientRect();
      const scX=VW/rect.width, scY=VH/rect.height;
      const sx=(e.clientX-rect.left)*scX, sy=(e.clientY-rect.top)*scY;
      if(sx>=0&&sy>=0&&sx<=VW&&sy<=VH){
        S.mouseWorld={x:sx/S.camZoom+S.camX, y:sy/S.camZoom+S.camY};
      }
    }
    rtsUpdateViewportCursor();
  });
  window.addEventListener('mouseup', ()=>{
    camDragActive=false;
    if(dragSelActive) _applyDragSelect();
    dragSelActive=false;
    setTimeout(()=>camDragging=false, 50);
  });

  // Touch drag
  wrap.addEventListener('touchstart', e=>{
    const t=e.touches[0];
    camDragging=true;
    camDragStartX=t.clientX; camDragStartY=t.clientY;
    camDragCamX=S.camX; camDragCamY=S.camY;
  },{passive:true});
  wrap.addEventListener('touchmove', e=>{
    if(!camDragging) return;
    const t=e.touches[0];
    S.camX = camDragCamX - (t.clientX - camDragStartX);
    S.camY = camDragCamY - (t.clientY - camDragStartY);
    clampCam();
  },{passive:true});
  wrap.addEventListener('touchend', ()=>{ camDragging=false; });

  // Scroll wheel: zoom toward cursor (vertical), pan horizontal (horizontal scroll)
  wrap.addEventListener('wheel', e=>{
    const game = document.getElementById('dso-game');
    if(!game || game.style.display==='none') return;
    e.preventDefault();
    if(e.deltaX) { S.camX += e.deltaX / S.camZoom; clampCam(); return; }
    const canvas2=document.getElementById('rts-canvas');
    if(!canvas2) return;
    const rect=canvas2.getBoundingClientRect();
    const scX=VW/rect.width, scY=VH/rect.height;
    const sx=(e.clientX-rect.left)*scX, sy=(e.clientY-rect.top)*scY;
    const worldX=sx/S.camZoom+S.camX, worldY=sy/S.camZoom+S.camY;
    const factor=e.deltaY<0?CAM_ZOOM_FACTOR:1/CAM_ZOOM_FACTOR;
    S.camZoom=Math.max(0.4,Math.min(3,S.camZoom*factor));
    S.camX=worldX-sx/S.camZoom;
    S.camY=worldY-sy/S.camZoom;
    clampCam();
  },{passive:false});

  // LEFT CLICK — select / build
  wrap.addEventListener('click', e=>{
    if(camDragging) return; // ignore if was dragging
    rtsHandleClick(e);
  });

  // RIGHT CLICK — move / attack
  wrap.addEventListener('contextmenu', e=>{
    rtsHandleRightClick(e);
  });
}

// Attack-move needs a distinct visual cue before the destination is chosen.
function rtsUpdateViewportCursor(){
  const wrap=document.getElementById('rts-viewport-wrap');
  if(!wrap) return;
  wrap.classList.toggle('rts-attack-move-armed', S.attackMoveMode);
  if(!S.attackMoveMode){
    wrap.style.cursor=S.buildStructureMode||S.deployDarkShipMode||dragSelActive?'crosshair':'default';
  } else {
    wrap.style.cursor='';
  }
}

function tickCamera(){
  if(keysHeld['ArrowLeft']||keysHeld['a']||keysHeld['A']) S.camX-=CAM_SPEED;
  if(keysHeld['ArrowRight']||keysHeld['d']||keysHeld['D']) S.camX+=CAM_SPEED;
  if(keysHeld['ArrowUp']||keysHeld['w']||keysHeld['W']) S.camY-=CAM_SPEED;
  if(keysHeld['ArrowDown']||keysHeld['s']||keysHeld['S']) S.camY+=CAM_SPEED;
  clampCam();
}

function _applyDragSelect(){
  if(S.gameOver) return;
  const canvas=document.getElementById('rts-canvas');
  if(!canvas) return;
  const rect=canvas.getBoundingClientRect();
  const scX=VW/rect.width, scY=VH/rect.height;

  // Convert client coords to world coords
  const wx1=(Math.min(dragSelStartCX,dragSelCurCX)-rect.left)*scX/S.camZoom+S.camX;
  const wy1=(Math.min(dragSelStartCY,dragSelCurCY)-rect.top )*scY/S.camZoom+S.camY;
  const wx2=(Math.max(dragSelStartCX,dragSelCurCX)-rect.left)*scX/S.camZoom+S.camX;
  const wy2=(Math.max(dragSelStartCY,dragSelCurCY)-rect.top )*scY/S.camZoom+S.camY;

  const side=mySide();
  for(const ent of S.entities) ent.selected=false;
  S.selected=[];

  for(const ent of S.entities){
    if(ent.side!==side) continue;
    if(ent.type!=='warrior'&&ent.type!=='worker') continue;
    if(ent.x>=wx1&&ent.x<=wx2&&ent.y>=wy1&&ent.y<=wy2){
      ent.selected=true;
      S.selected.push(ent);
    }
  }

  if(S.buildPopupOpen) closeBuildPopup();
  if(S.selected.length>0){
    const n=S.selected.length;
    rtsSetLog(n+' unit'+(n>1?'s':'')+' selected');
  }
}


//# sourceMappingURL=camera.js.map
